import React from 'react'
import Track from '../Track/Track'
import Slider from '../Slider/Slider'
import './Instrument.css'

const Instrument = ({id, currentTrack, name, playing, toPlay, playerPlaying, tracks, handleOnOff, handleTrackSelect, handleVolume}) => {
  const toggleButton = (playing && playerPlaying === 'started') ? 'On' : 'Off'
  const toggleClass = (playing && playerPlaying === 'started') ? 'on' : 'off'
  const trackView = tracks.map((track, index) => (
    <Track
      key={track.id}
      rowNum={track.id}
      toPlay={index === toPlay}
      selected={index === currentTrack}
      playing={playing}
      name={track.name}
      instrument={name}
      playerPlaying={playerPlaying}
      handleTrackSelect={(inst, track) => handleTrackSelect(inst, track)}
    />
  ))
  return (
    <div className='instrumentBox'>
      <div>
        <h3 className='subtitle'>{name}</h3>
        <div>
          {trackView}
        </div>
      </div>
      <div className='instrumentBottom'>
        <button
          className={'onOff ' + toggleClass}
          onClick={() => handleOnOff(id, name)}>{toggleButton}
        </button>
        <Slider 
          inst={name}
          handleVolume={(inst, e) => handleVolume(inst, e)}
        />
      </div>
    </div>
  )
}

export default Instrument


// WEBPACK FOOTER //
// ./src/Instrument/Instrument.js